import React, { useContext, useState, useEffect } from 'react';
import { UserContext } from '../../contexts/context-layout-user';
import PropTypes from 'prop-types';
import ModalDialogComponent from '../../components/dialog/dialog-component';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import DeleteIcon from '@mui/icons-material/Delete';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import { visuallyHidden } from '@mui/utils';
import { useTranslation } from "react-i18next";
import StatusBadge from './StatusBadge';
import StatusBadgeCircle from './StatusBadgeCircle';

import infoIcon from '../../assets/inf_icon.png';
import { editCase } from '../../actions/cases';
import { errors } from '../../config/errors';
import Collapse from '@mui/material/Collapse';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Button, LinearProgress } from '@mui/material';
import { nkGenerator } from '../../actions/n-k';

const formatDate = (mongoDateString) => {
  if (!mongoDateString) return '';
  const date = new Date(mongoDateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year.toString()}`;
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  {
    id: 'nombre',
    numeric: false,
    disablePadding: true,
    label: 'name',
  },
  {
    id: 'fecha',
    numeric: true,
    disablePadding: false,
    label: 'date',
  },
  {
    id: 'descripción',
    numeric: true,
    disablePadding: false,
    label: 'description',
  },

];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;

  const [t, i18next] = useTranslation("global")

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>

      <TableRow>
        <TableCell padding="checkbox">
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align='center'
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {t(`board.casesHistory.${headCell.label}`)}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) {
  const { setFlterCase, filterCase } = useContext(UserContext);


  const { numSelected } = props;
  const [caseDescription, setCaseDescription] = useState('')
  const [caseName, setCaseName] = useState('')
  const [caseDate, setCaseDate] = useState('')

  const [t, i18next] = useTranslation("global")

  useEffect(() => {

    let filterCaseNew = {
      ...filterCase,
      caseDescription: caseDescription,
      caseName: caseName,
      caseDate: caseDate
    }
    setFlterCase(filterCaseNew)

  }, [caseDescription, caseName, caseDate])

  return (

    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },

      }}
    >
      <TableRow>

        <TableCell class="col-md-4" style={{ paddingLeft: '30px' }}>
          <Typography
            variant="h7"
            id="tableTitle"
            component="div"
          >
            {t("board.casesHistory.studyCases")}
          </Typography>
          <TextField
            hiddenLabel
            id="filled-hidden-label-small"
            size="small"
            value={caseName}
            onChange={(event) => {
              setCaseName(event.target.value)

            }}
          />
        </TableCell>
        <TableCell class="col-md-4" style={{ paddingLeft: '30px' }}>
          <Typography
            variant="h7"
            id="tableTitle"
            component="div"
          >
            {t("board.casesHistory.date")}
          </Typography>
          <TextField
            hiddenLabel
            id="filled-hidden-label-small"
            size="small"
            value={caseDate}
            onChange={(event) => setCaseDate(event.target.value)}
          />
        </TableCell>
        <TableCell class="col-md-4" style={{ paddingLeft: '30px' }}>
          <Typography
            variant="h7"
            id="tableTitle"
            component="div"
          >
            {t("board.casesHistory.description")}
          </Typography>
          <TextField
            hiddenLabel
            id="filled-hidden-label-small"
            size="small"
            value={caseDescription}
            onChange={(event) => setCaseDescription(event.target.value)}
          />
        </TableCell>
      </TableRow>

    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

function CaseRow({ caseItem, selected, handleClick, checkDisable, setModalMessages, setIdCase, isFamilyCase = false, handleRowClick, infoTxtIds = false }) {
  const [t] = useTranslation("global");
  const isSelected = selected.includes(caseItem._id);

  return (
    <TableRow hover selected={isSelected}>
      <TableCell padding="checkbox">
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={(event) => handleClick(event, caseItem._id)}
          disabled={checkDisable && !isSelected}
        />
      </TableCell>
      <TableCell style={{width: '65%'}}>
        {caseItem.caseResult[0].caseName}
        {infoTxtIds && (
          <Button
            style={{ borderRadius: "20px", border: "1px solid rgb(144, 143, 145)", color: "#7220db", fontSize: "10px", marginLeft: "10px", padding: "2px 8px" }}
            onClick={(event) => { handleRowClick(event, caseItem._id) }}
          >
            {t("board.casesHistory.n-k")}
          </Button>
        )}
      </TableCell>
      <TableCell align="center">
        {!isFamilyCase && formatDate(caseItem.creationDate)}
      </TableCell>
      <TableCell align="center">
        {isFamilyCase ? (
          <StatusBadgeCircle
            status={caseItem.process ? 'processing' : 'finished'}
            failStatus={caseItem.failStatus}
          />
        ) : (
          <StatusBadge
            status={caseItem.process ? 'processing' : 'finished'}
            failStatus={caseItem.failStatus}
          />
        )}
      </TableCell>
      <TableCell align="center">
        <IconButton
          aria-label="delete"
          onClick={() => {
            setModalMessages(true);
            setIdCase(caseItem._id);
          }}
        >
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}

function FamilyRow({ family, cases, selected, handleClick, handleFamilySelect, checkDisable, setModalMessages, setIdCase }) {
  const [open, setOpen] = useState(false);
  const allFamilyCasesSelected = cases.every(caseItem => selected.includes(caseItem._id));
  const someFamilyCasesSelected = cases.some(caseItem => selected.includes(caseItem._id));
  const familyDate = cases.length > 0 ? formatDate(cases[0].creationDate) : '';

  return (
    <>
      <TableRow hover>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            checked={allFamilyCasesSelected}
            indeterminate={someFamilyCasesSelected && !allFamilyCasesSelected}
            onChange={() => handleFamilySelect(family, cases)}
            disabled={checkDisable && !allFamilyCasesSelected}
          />
        </TableCell>
        <TableCell>
          <Box display="flex" alignItems="center">
            {family.familyName || `Familia ${family.familyId}`}
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setOpen(!open);
              }}
              style={{ marginLeft: 8, color: 'orange' }} // Set icon color to orange
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </Box>
        </TableCell>
        <TableCell align="center">{familyDate}</TableCell>
        <TableCell align="center">
          <StatusBadge
            status={cases.some(c => c.process) ? 'processing' : 'finished'}
            failStatus={cases.some(c => c.failStatus)}
          />
        </TableCell>
        <TableCell align="center">
          <IconButton
            aria-label="delete"
            onClick={() => {
              setModalMessages(true);
              setIdCase(cases[0]._id);
            }}
          >
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      {cases.map((caseItem) => (
        <TableRow key={caseItem._id} style={{ background: 'transparent' }}>
          <TableCell style={{ padding: 0, border: 'none' }} colSpan={5}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box marginLeft={4}> {/* Añade indentación aquí */}
                <Table size="small" style={{ border: 'none' }}>
                  <TableBody>
                    <CaseRow
                      caseItem={caseItem}
                      selected={selected}
                      handleClick={handleClick}
                      checkDisable={checkDisable}
                      setModalMessages={setModalMessages}
                      setIdCase={setIdCase}
                      isFamilyCase={true}
                    />
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}

export default function TableCases() {
  const {
    cases,
    setFilteredCases,
    filtrarArray,
    setLayers,
    filterCase,
    setFilteredCasesMenu,
    filteredCasesMenu,
    setCases,
    layers,
    setDeleteMultipleCases,
    nkIds
  } = useContext(UserContext);

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('nombre');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [modalMessages, setModalMessages] = useState(false);
  const [idCase, setIdCase] = useState(null);
  const [checkDisable, setCheckDisable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [caseLoading, setCaseLoading] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [message, setMessage] = useState('');
  const [t] = useTranslation("global");

  // Agrupar casos por familia
  const { families, standaloneCases } = cases.reduce((acc, caseItem) => {
    if (caseItem.familyId) {
      const familyId = caseItem.familyId;
      if (!acc.families[familyId]) {
        acc.families[familyId] = {
          familyId,
          familyName: caseItem.familyName || `Familia ${familyId}`,
          cases: []
        };
      }
      acc.families[familyId].cases.push(caseItem);
    } else {
      acc.standaloneCases.push(caseItem);
    }
    return acc;
  }, { families: {}, standaloneCases: [] });

  // Ordenar y combinar
  const sortedItems = [
    ...Object.values(families),
    ...standaloneCases
  ].sort((a, b) => {
    const dateA = a.cases?.[0]?.creationDate || a.creationDate;
    const dateB = b.cases?.[0]?.creationDate || b.creationDate;
    return new Date(dateB) - new Date(dateA);
  });

  // Filtrar según búsqueda
  const filteredItems = sortedItems.filter(item => {
    const caseItems = item.cases || [item];
    return caseItems.some(caseItem =>
      caseItem.caseResult[0].caseName.toUpperCase().includes(filterCase.caseName.toUpperCase()) &&
      formatDate(caseItem.creationDate).toUpperCase().includes(filterCase.caseDate.toUpperCase()) &&
      (!filterCase.caseDescription ||
        (caseItem.caseResult[0].caseDescription &&
          caseItem.caseResult[0].caseDescription.toUpperCase().includes(filterCase.caseDescription.toUpperCase())))
    );
  });

  const handleFamilySelect = (family, familyCases) => {
    const allSelected = familyCases.every(caseItem => selected.includes(caseItem._id));
    let newSelected = allSelected
      ? selected.filter(id => !familyCases.some(c => c._id === id))
      : [...new Set([...selected, ...familyCases.map(c => c._id)])];

    setDeleteMultipleCases(newSelected);
    updateSelection(newSelected);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = [...selected, id];
    } else {
      newSelected = selected.filter(item => item !== id);
    }
    setDeleteMultipleCases(newSelected);

    updateSelection(newSelected);
  };

  const handleRowClick = (event, id) => {
    setLoading(true);
    setCaseLoading(id);
    nkGenerator({ id })
      .then((response) => {
        if (response.status === 200) {
          setLoading(false);
          setOpenModal(true);
          setMessage(
          t('board.casesHistory.n-kExecuted', {
            actual: response.response.nkData.con_nk_actual,
            habilitados: response.response.nkData.con_nk_habilitados
          })
        );
        } else {
          setLoading(false);
          setOpenModal(true);
          setMessage("board.casesHistory.n-kError");
          console.error("Failed to fetch N-K data:", response);
        }
      })
      .catch(error => {
        setOpenModal(true);
        setMessage("board.casesHistory.n-kError");
        setLoading(false);
        errors.addErroLog({
          data: {
            url: window.location,
            error: error.toString(),
            message: error.message,
            file: error.file,
            line: error.line
          }
        });
      });
  };

  const updateSelection = (newSelected) => {
    setCheckDisable(newSelected.length >= 15);
    setSelected(newSelected);
    setFilteredCases(filtrarArray(cases, newSelected, '_id'));
  };

  const handleSelectAllClick = (event) => {
    const newSelected = event.target.checked ? cases.map(n => n._id) : [];
    updateSelection(newSelected);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDelete = () => {
    const jsonCase = { active: false };
    editCase({ jsonCase, idCase })
      .then((response) => {
        if (response.status === 200) {
          const temporal = filteredCasesMenu.filter(ele => ele._id !== idCase);
          setFilteredCasesMenu(temporal);
          setCases(cases.filter(ele => ele._id !== idCase));
          setModalMessages(false);
          if (layers._id && layers._id === idCase) {
            setSelected([]);
            setLayers({});
          }
        }
      })
      .catch(error => {
        errors.addErroLog({
          data: {
            url: window.location,
            error: error.toString(),
            message: error.message,
            file: error.file,
            line: error.line
          }
        });
        console.error(error);
      });
  };

  return (
    <>
      <ModalDialogComponent
        view={modalMessages}
        tittle={t("board.deleteCase.confirm")}
        message={t("board.deleteCase.deleteDescription")}
        buttons={[
          {
            value: t("board.deleteCase.accept"),
            onclick: handleDelete
          }
        ]}
      />
       <ModalDialogComponent
        view={openModal}
        tittle={t("board.casesHistory.n-kTitle")}
        message={t(message)}
         buttons={[
          {
            value: t("board.deleteCase.accept"),
            onclick: () => setOpenModal(false)
          }
        ]}
      />

      <EnhancedTableToolbar numSelected={selected.length} />

      <TableContainer sx={{ maxHeight: "calc(100vh - 300px)" }}>
        <Table stickyHeader>
          <EnhancedTableHead
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={cases.length}
          />
          <TableBody>
            {stableSort(filteredItems, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((item) => (

                item.cases ? (
                  <FamilyRow
                    key={`family-${item.familyId}`}
                    family={item}
                    cases={item.cases}
                    selected={selected}
                    handleClick={handleClick}
                    handleFamilySelect={handleFamilySelect}
                    setModalMessages={setModalMessages}
                    setIdCase={setIdCase}
                  />
                ) : (
                  <>
                    <CaseRow
                      key={`case-${item._id}`}
                      caseItem={item}
                      selected={selected}
                      handleClick={handleClick}
                      setModalMessages={setModalMessages}
                      setIdCase={setIdCase}
                      handleRowClick={handleRowClick}
                      infoTxtIds={nkIds.includes(item._id)}
                    />
                    {loading && caseLoading === item._id && (
                      <LinearProgress sx={{ width: '800%' }} />
                    )}
                  </>
                )
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={filteredItems.length}
        rowsPerPage={rowsPerPage}
        page={page}
        style={{ position: "relative" }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage={t("board.casesHistory.rowsPerPage")}
      >

      </TablePagination>
    </>
  );
}